import { render, staticRenderFns } from "./SideDialogEvent.vue?vue&type=template&id=37601314&scoped=true&"
import script from "./SideDialogEvent.vue?vue&type=script&lang=js&"
export * from "./SideDialogEvent.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogEvent.vue?vue&type=style&index=0&id=37601314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37601314",
  null
  
)

component.options.__file = "SideDialogEvent.vue"
export default component.exports